import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; 
import BackToTop from "../../components/elements/BackToTop";
import Header from "../../components/Layout/Header";
import navImg1 from "../../assets/images/resources/logo1.svg";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import CtaSection from "../../components/Common/CtaSection";
import shapeImageUrl from "../../assets/images/shapes/cta-one-shape-1.png";
import ProjectDetailsMain from "./ProjectDetailsMain";
import projectList from "../project/projectList";

// Breadcrumbs Background Image

const ProjectDetails = () => {
  const { projectId } = useParams();
  const [isVisible, setIsVisible] = useState(false);

  const project = projectList.find((p) => p.id === projectId);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    if (scrollTop > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  if (!project) return <div className="text-center py-5">Project not found</div>;

  return (
    <React.Fragment>
      <Header
        navImg={navImg1}
        parentMenu="/projects"
        activeMenu="/projects"
      />
      {/* SiteBreadcrumb */}
      <SiteBreadcrumb
        pageTitle={project.details.title}
        pageName="Elevator Details"
        breadcrumbsImg={bannerbg}
      />
      {/* SiteBreadcrumb */}
      <ProjectDetailsMain project={project} />
      {/*cta-section */}
      <CtaSection
        className="cta-one" // Custom class name
        breadcrumbsImg={bannerbg}
        shapeImageUrl={shapeImageUrl}
        title="Need any help? contact us!"
        text="Need help?"
        phoneNumber="+91 90332 26011"
      />
      {/*cta-section end */}
      <BackToTop scroll={isVisible} />
      <Footer />
    </React.Fragment>
  );
};

export default ProjectDetails;
